import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

const FullScreenLoader = ({ open }) => {
  return (
    <Backdrop
      sx={{
        color: "#1DA7A7",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default FullScreenLoader;
